export default ({ baseGuesses, repeatCount }) => baseGuesses * repeatCount;
//# sourceMappingURL=scoring.js.map